<template>
  <div class="bottom-backView">
    <!-- <img
      src="https://cdn.spbcn.org/spbcnWeb/cebsb/new/3nd_photo/down_back_01.png"
      alt=""
      class="down_background"
    /> -->
    <div class="bottom-contact-backview">
      <!-- 左侧：Contact us 部分 -->
      <div class="contact-backview-leftview">
        <div class="center-contactTitle">Contact us</div>
        <div class="social-icons-container">
          <div class="view-imgback" @click="to2">
            <img
              src="https://cdn.spbcn.org/spbcnWeb/cebsb/homepage_media7.png"
              alt=""
              class="view-img-class"
            />
          </div>
          <div class="view-imgback" @click="to1">
            <img
              src="https://cdn.spbcn.org/spbcnWeb/cebsb/homepage_media1.png"
              alt=""
              class="view-img-class"
            />
          </div>
          <!-- <div class="view-imgback">
            <img
              src="https://cdn.spbcn.org/spbcnWeb/cebsb/homepage_media2.png"
              alt=""
              class="view-img-class"
            />
          </div> -->
          <el-popover placement="top" trigger="hover">
            <img src="https://cdn.spbcn.org/spbcnWeb/newspbcn/erweima.png" alt="">
            <div class="view-imgback" slot="reference">
              <img
                src="https://cdn.spbcn.org/spbcnWeb/cebsb/homepage_media3.png"
                alt=""
                class="view-img-class"
              />
            </div>
          </el-popover>
          <!-- <div class="view-imgback">
            <img
              src="https://cdn.spbcn.org/spbcnWeb/cebsb/homepage_media4.png"
              alt=""
              class="view-img-class"
            />
          </div> -->
          <!-- <div class="view-imgback">
            <img
              src="https://cdn.spbcn.org/spbcnWeb/cebsb/homepage_media5.png"
              alt=""
              class="view-img-class"
            />
          </div> -->
          <!-- <div class="view-imgback">
            <img
              src="https://cdn.spbcn.org/spbcnWeb/cebsb/homepage_media6.png"
              alt=""
              class="view-img-class"
            />
          </div> -->
        </div>
        <div class="center-contactbackview">
          <img
            src="https://cdn.spbcn.org/spbcnWeb/cebsb/new/3nd_photo/cebeb_homepage_littleicon1.png"
            alt=""
            class="center-contact-leftimg"
          />
          <div class="center-contactStr">
            Room 603, Building C, Oriental Media Center, Chaoyang District, Beijing, China
          </div>
        </div>
        <div class="center-contactbackview">
          <img
            src="https://cdn.spbcn.org/spbcnWeb/cebsb/new/3nd_photo/cebeb_homepage_littleicon2.png"
            alt=""
            class="center-contact-leftimg"
          />
          <div class="center-contactStr">400-0863-988</div>
        </div>
        <div class="center-contactbackview">
          <img
            src="https://cdn.spbcn.org/spbcnWeb/cebsb/new/3nd_photo/cebeb_homepage_littleicon3.png"
            alt=""
            class="center-contact-leftimg"
          />
          <div class="center-contactStr">cebsb@spbcn.org</div>
        </div>
      </div>
      <!-- 分隔线 -->
      <div class="contact-backview-line"></div>
      <!-- 中间：Home 导航部分 -->
      <div class="contact-backview-centerview">
        <router-link to="/HomeView" class="center-contactTitle" @click.native="handleNavClick(0)">Home</router-link>
        <div class="nav-links-container">
          <router-link to="/aboutBackground" class="nav-link" @click.native="handleNavClick(1)">About CEBSB</router-link>
          <router-link to="/invGameType" class="nav-link" @click.native="handleNavClick(2)">About Competition</router-link>
          <router-link to="/eLearn" class="nav-link" @click.native="handleNavClick(3)">E-Learn</router-link>
          <router-link to="/globalFinals" class="nav-link" @click.native="handleNavClick(4)">Global Finals</router-link>
          <router-link to="/FAQ" class="nav-link" @click.native="handleNavClick(5)">FAQ</router-link>
          <router-link to="/joinUs" class="nav-link" @click.native="handleNavClick(6)">Join Us</router-link>
        </div>
      </div>
      <!-- 分隔线 -->
      <div class="contact-backview-line"></div>
      <!-- 右侧：品牌Logo -->
      <div class="contact-backview-rightview">
        <img
          src="https://cdn.spbcn.org/spbcnWeb/cebsb/homepage_logo2.png"
          alt=""
          class="backview-leftview-image"
        />
      </div>
    </div>
    <!-- 底部版权信息 -->
    <div class="copyright-bar">
      <div class="copyright-text">© 2026 Chinese-English Bilingual Spelling Bee</div>
      <!-- © 2014-2026 spbcn.org 版权所有 | 京ICP备17055067号 -->
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      bottomImgList: [
        { url: require('../assets/images/homepage_photo1.png') },
        { url: require('../assets/images/homepage_photo2.png') },
        { url: require('../assets/images/homepage_photo3.png') }
      ]
    }
  },
  methods: {
    scrollToTop () {
      try {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
      } catch (e) {
        window.scrollTo(0, 0)
      }
    },
    handleNavClick (index) {
      this.scrollToTop()
      this.$store.commit('SET_ACTIVEMENUINDEX', index)
    },
    to1 () {
      window.open('https://www.facebook.com/profile.php?id=100088886441816')
    },
    to2 () {
      window.open('https://www.instagram.com/cebspellingbee/')
    }
  }
}
</script>

<style lang="less" scoped>
.bottom-backView {
  width: 1400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.down_background {
  width: 100%;
  height: 212px;
  object-fit: cover;
  object-position: center;
  z-index: 1;
}

.bottom-contact-backview {
  width: 100%;
  min-height: 160px;
  padding: 30px 0px;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: space-around;
  background-color: #4a4a4a;
}

.contact-backview-leftview {
  flex: 1;
  max-width: 350px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-left: 20px;
}

.contact-backview-centerview {
  flex: 1;
  max-width: 300px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 0 20px;
}

.contact-backview-rightview {
  flex: 1;
  max-width: 400px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 0;
  align-self: stretch;
}

.contact-backview-line {
  width: 1px;
  height: 150px;
  margin: 0 20px;
  background: transparent;
  border-left: 1px dotted #999;
}

.backview-leftview-image {
  width: 100%;
  position: relative;
  left: 20px;
  max-width: 300px;
  height: auto;
  object-fit: contain;
}

.social-icons-container {
  margin-top: 15px;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
}

.view-imgback {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background-color: #ffffff;
  cursor: pointer;
}

.view-img-class {
  width: 20px;
  height: 20px;
}

.center-contactbackview {
  width: 100%;
  margin-top: 12px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
}

.center-contact-leftimg {
  width: 12px;
  height: 12px;
  flex-shrink: 0;
}

.center-contactStr {
  flex: 1;
  font-size: 10px;
  color: #ffffff;
  text-align: left;
  margin-left: 8px;
  line-height: 1.5;
}

.center-contactTitle {
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  color: #ffffff;
  margin-bottom: 0;
  width: 100%;
  text-decoration: none;
}

.nav-links-container {
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  width: 100%;
}

.nav-link {
  font-size: 10px;
  color: #ffffff;
  text-decoration: none;
  text-align: center;
  transition: color 0.3s ease;

  &:hover {
    color: #cccccc;
  }
}

.copyright-bar {
  width: 100%;
  background-color: #000000;
  padding: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.copyright-text {
  font-size: 10px;
  color: #ffffff;
  text-align: center;
}
</style>
